export interface DescriptionCardGalleryImage {
  preview: string;
  fullSize: string;
}
